var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.234,
    height: 15.729,
    viewBox: "0 0 12.234 15.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.874,16.981a1.753,1.753,0,0,0,1.748,1.748h6.991a1.753,1.753,0,0,0,1.748-1.748V6.5H5.874ZM17.234,3.874H14.175L13.3,3H8.932l-.874.874H5V5.621H17.234Z",
    transform: "translate(-5 -3)",
    fill: "#4f5b6d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trash-can.7d092e482fd2cab8fb8b584f3af5fd9b.svg";
export { ForwardRef as ReactComponent };